import Resource from '@/api/core/resource'

class Entidad extends Resource {
  constructor () {
    super('administracion/entidades')
  }

  obtenerEspacio () {
    return this.request.get(this.uri.concat('/espacio-utilizado'))
  }
}

export default new Entidad()
